<template>
  <div>
    <div data-cy="form-label" class="b-dialog__top-panel">
      <h2>{{getPaymentName()}}</h2>
      <button class="b-btn b-btn_border_none" @click="cancel">
        <dynamic-icon icon="close" />
      </button>
    </div>
    <form class="col-12 b-form b-dialog__form mt-4">
      <div class="row">
        <div class="col-6">
          <div>
            <label>
              {{$t('CONTENT.payments.payment_lease_rate')}}:
              <span class="b-form__required">*</span>
            </label>
            <numeric class="b-numeric" controls :min="0" :max="1000000000000" v-model="editPayment.leaseRate"></numeric>
          </div>
        </div>
      </div>
      <div class="row mt-5">
        <div class="col-6">
          <div class="b-form__container b-form__container_type_flex">
            <button
              class="b-btn b-btn_type_primary"
              type="button"
              @click="save"
            >{{$t('CONTENT.save')}}</button>
            <button
              class="b-btn b-btn_type_empty"
              @click.prevent="cancel"
            >{{$t('CONTENT.cancel')}}</button>
          </div>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  props: {
    payment: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      editPayment: null,
    };
  },
  computed: {
    ...mapGetters(["getPaymentNames"])
  },
  created() {
    this.editPayment =  _.cloneDeep(this.payment);
  },
  methods: {
    cancel() {
      this.$emit("close");
    },
    save() {
      this.$emit('save', this.editPayment);
      this.$emit("close");
    },
    getPaymentName() {
      for (let i = 0; i < this.getPaymentNames.length; i++) {
        if (
          this.getPaymentNames[i].idInDB === this.payment.paymentNameId
        ) {
          return this.getPaymentNames[i].name;
        }
      }
    }
  }
};
</script>

<style>
</style>
